// import CONFIGURACIONES from "../utils/constants";
// import INIT from "../util/UtilObjectsInit";
import { Functions } from "./Functions";
import CONFIGURACIONES from "../util/constants";
export const Http = () => {
    const customFetch = async (endpoint, options) => {
        try {
            const isFormData = options.body instanceof FormData; // <-- NUEVA COMPROBACIÓN
            // console.log('endpoint', endpoint)
            let defaultHeader = {
                "accept": "application/json",
            };

            if (!isFormData) {
                defaultHeader["content-type"] = CONFIGURACIONES.HEADER_TYPE;
            }

            console.log('defaultHeader', defaultHeader);
            

            const controller = new AbortController();
            options.signal = controller.signal;

            options.method = options.method || "GET";
            // console.log(`endpoint: ${endpoint} | ${CONFIGURACIONES.ENDPOINTS.LOGIN} | ${CONFIGURACIONES.ENDPOINTS.IDENTIFY_COMPANY}`);
            
            if (endpoint != CONFIGURACIONES.ENDPOINTS.LOGIN && endpoint != CONFIGURACIONES.ENDPOINTS.IDENTIFY_COMPANY) {
                const tokenAccess =  Functions().decryptData(localStorage.getItem('token'))??'';
                const tokenHeader = {
                    Authorization: `Bearer ${tokenAccess}`,
                };   
                
                options.headers = { ...tokenHeader, ... options.headers };
            } else {
                options.headers = { ... options.headers, 
                                    ... {'Public-Key': Functions().decryptData(localStorage.getItem('Public-Key')??'') } };
            }

            options.headers = options.headers
            ? { ...defaultHeader, ...options.headers }
            : defaultHeader;

            // console.log('headers', options);
            console.log('body', options);
            
            if (options.body && !isFormData) {
                options.body = JSON.stringify(options.body);
            } else if (!options.body) {
                delete options.body;
            }

            // options.body = JSON.stringify(options.body) || false;
            // if (!options.body) delete options.body;

            setTimeout(() => controller.abort(), 3000);
            const res = await fetch(endpoint, options);
            const isDownload = endpoint.includes('/descargar');
            let dataResponse = null;

            if (isDownload) {
                return res;
            } else {
                dataResponse = await res.json().catch(() => null);
            }

            return {
                ...dataResponse,  // el body completo
                httpStatus: res.status,       // Código HTTP (200, 400, 500, etc.)
                ok: res.ok,                   // true/false según el rango 200-299
                status: dataResponse?.status || false,     // "success" | "error" (propiedad de tu API)
            };
            // return fetch(endpoint, options)
            // .then((res) =>
            //     res.json()
            //     // res.ok
            //     // ? res.json()
            //     // : Promise.reject({
            //     //     err: true,
            //     //     status: res.status || "00",
            //     //     statusText: res.statusText || "Ocurrió un error",
            //     // })
            // )
            // .catch((err) => err);
        } catch (err) {
            return {
                httpStatus: "00",
                ok: false,
                status: "error",
                errors: { message: err.message || "Ocurrió un error de red" },
            };
        }
    };

    const get = (url, options = {}) => customFetch(url, options);

    const post = (url, options = {}) => {
        options.method = "POST";
        return customFetch(url, options);
    };

    const put = (url, options = {}) => {
        options.method = "PUT";
        return customFetch(url, options);
    };

    const del = (url, options = {}) => {
        options.method = "DELETE";
        return customFetch(url, options);
    };

    return {
        get,
        post,
        put,
        del,
    };
};